import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import IntelligentInboxSettingsClientFactory from './intelligentInboxSettingsClient.factory';
import type {
    IntelligentInboxSettingsClientInterface,
    IntelligentInboxSettingsFormData,
    IntelligentInboxSettingsResponse,
} from './intelligentInboxSettingsClient.types';

class IntelligentInboxSettingsClient extends ContextClient<IntelligentInboxSettingsClientInterface> {
    constructor() {
        super(IntelligentInboxSettingsClientFactory);
    }

    getIntelligentInboxSettings(context: ClientContext): AxiosPromise<IntelligentInboxSettingsResponse> {
        const client = this.getClient(context);
        return client.getIntelligentInboxSettings();
    }

    updateIntelligentInboxSettings(
        context: ClientContext,
        data: IntelligentInboxSettingsFormData,
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<IntelligentInboxSettingsResponse> {
        const client = this.getClient(context);
        return client.updateIntelligentInboxSettings(data, extraConfig);
    }
}

export default new IntelligentInboxSettingsClient();
